import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { Toggle, Link } from 'carbon-components-react';

const ShowRecentsToggle: React.FC<Props> = ({
  recentVisible,
  setRecentVisible,
  userId,
  selectedRecentDuration,
  setSelectedRecentDuration
}) => {
  const [showDurationSelection, setShowDurationSelection] =
    useState<boolean>(false);

  const handleDurationClick = () => {
    setShowDurationSelection(true);
  };

  const handleDurationSelectionClick = (duration: number) => {
    Cookies.set(
      'default-show-recents-duration',
      { id: userId, duration },
      { secure: true, sameSite: 'strict' }
    );
    setSelectedRecentDuration(duration);
    setShowDurationSelection(false);
  };

  return (
    <div className="show-recents-toggle-container">
      <div className="toggle-container">
        <Toggle
          id="ShowRecentsToggle"
          size="sm"
          aria-label="Show recents"
          labelA="Show recents"
          labelB="Show recents"
          toggled={recentVisible}
          onToggle={(checked: boolean) => setRecentVisible(checked)}
        />
      </div>
      {!showDurationSelection ? (
        <div
          className="selected-duration-container duration-style"
          onClick={handleDurationClick}
        >
          {selectedRecentDuration} day{selectedRecentDuration > 1 ? 's' : ''}
        </div>
      ) : (
        <div className="duration-selection-container duration-style">
          <Link onClick={() => handleDurationSelectionClick(1)}>1</Link>
          <span className="duration-selection-separator">|</span>
          <Link onClick={() => handleDurationSelectionClick(7)}>7</Link>
          <span className="duration-selection-separator">|</span>
          <Link onClick={() => handleDurationSelectionClick(28)}>28</Link>
          <span>days</span>
        </div>
      )}
    </div>
  );
};

type Props = {
  recentVisible: boolean;
  setRecentVisible: Function;
  userId: number;
  selectedRecentDuration: number;
  setSelectedRecentDuration: Function;
};

export default React.memo(ShowRecentsToggle);
